import { useNavigate } from 'react-router-dom';
import { MonoIcon } from '@/components/ui/MonoIcon';
import type { AppIcon } from '@/lib/icons';
import { cn } from '@/lib/utils';

interface NavItemProps {
  to: string;
  label: React.ReactNode;
  icon?: AppIcon;
  active?: boolean;
  className?: string;
  right?: React.ReactNode;
}

export function NavItem({ to, label, icon, active, className, right }: NavItemProps) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(to)}
      aria-current={active ? 'page' : undefined}
      className={cn(
        'h-7.5 flex w-full items-center rounded-md px-2 text-sm font-medium transition-colors',
        'hover:bg-muted hover:text-foreground',
        active ? 'bg-muted text-foreground' : 'text-foreground/80',
        className
      )}
    >
      {icon ? <MonoIcon type={icon} className="mr-2.5 shrink-0" /> : null}
      <span className="min-w-0 flex-1 truncate text-left">{label}</span>
      {right ? <span className="ml-2 shrink-0">{right}</span> : null}
    </button>
  );
}
